import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { SidebarGroup } from '@/components/ui/sidebar';

    import { type NavItem, type SharedData } from '@/types';
    import { usePage } from '@inertiajs/vue3';
    import NavMenu from '@/components/NavMenu.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'NavMain',
  props: {
    items: {}
  },
  setup(__props: any) {

    

    const page = usePage<SharedData>();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(SidebarGroup), { class: "px-[7px] py-0" }, {
    default: _withCtx(() => [
      _createVNode(NavMenu, { items: _ctx.items }, null, 8, ["items"])
    ]),
    _: 1
  }))
}
}

})